import { activationValueText } from "./roofingV2QualificationView";

const NOT_CONFIGURED = "not configured";

function readField(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key) || source[key] == null) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

function budgetsView(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { status: NOT_CONFIGURED, budgets: [] };
  }
  return {
    status: null,
    budgets: Object.keys(value).map((key) => ({
      key,
      value: typeof value[key] === "number" && Number.isFinite(value[key])
        ? value[key]
        : NOT_CONFIGURED,
    })),
  };
}

export function roofingV2DataView(settings) {
  const profile = settings && settings.data_profile;
  const budgets = budgetsView(settings && settings.budgets);
  const optOut = readField(profile, "opt_out");
  return {
    retentionClass: activationValueText(readField(profile, "retention_class")),
    region: activationValueText(readField(profile, "region")),
    optOut: optOut === "" ? '""' : optOut,
    budgetsStatus: budgets.status,
    budgets: budgets.budgets,
  };
}

export function releaseSloText(settings) {
  const profile = settings && settings.release_slo;
  const value = profile && !Array.isArray(profile) ? profile.profile_id : undefined;
  if (typeof value !== "string" || value.length === 0) {
    return NOT_CONFIGURED;
  }
  return value;
}
